import { Tooltip } from 'primereact/tooltip';
import { useRef, useMemo } from 'react';

const GlobalTooltip = ({ children, tooltip, position = 'bottom', style = {}, className, ...rest }) => {
  const uniqueId = useRef(useMemo(() => `tooltip-${Math.random().toString(36).substr(2, 9)}`, [])).current;

  return (
    <>
      <span
        id={tooltip ? uniqueId : undefined}
        data-pr-tooltip={tooltip || undefined}
        data-pr-position={tooltip ? position : undefined}
        style={tooltip ? style : { display: 'contents' }}
        className={tooltip ? className : undefined}
      >
        {children}
      </span>
      {tooltip && <Tooltip target={`#${uniqueId}`} {...rest} style={{ marginLeft: '10px' }} />}
    </>
  );
};

export default GlobalTooltip;
